module.exports = __webpack_public_path__ + "img/binance.cf9291b5.png";